import {
  getLockedDropTargetSprintId,
  getRawState,
  isDragActive,
} from './internalState';

export const MISSION_DROP_ATTR = 'data-sidebar-mission-drop-target';

/**
 * PERFORMANCE: diffed against last applied value so unchanged frames cost nothing
 * (repeated classList/attribute writes force style recalc even when values repeat).
 */
let appliedVisualClasses = { active: false, overSidebar: false };
let appliedHighlightId = null;

export function syncDragVisualClasses() {
  const state = getRawState();
  const active = state.active;
  const overSidebar = state.active && (state.isOverSidebar || !!state.hoverTargetSprintId);
  if (appliedVisualClasses.active !== active) {
    document.body.classList.toggle('mission-to-sidebar--active', active);
  }
  if (appliedVisualClasses.overSidebar !== overSidebar) {
    document.body.classList.toggle('mission-to-sidebar--over-sidebar', overSidebar);
  }
  appliedVisualClasses = { active, overSidebar };
}

export function clearSidebarRowHighlights() {
  document.querySelectorAll(`[${MISSION_DROP_ATTR}="true"]`).forEach((row) => {
    row.classList.remove('sidebar__item--drag-over');
    row.removeAttribute(MISSION_DROP_ATTR);
  });
  appliedHighlightId = null;
}

export function syncSidebarRowHighlights() {
  const state = getRawState();
  const highlightId = isDragActive()
    ? (state.hoverTargetSprintId || getLockedDropTargetSprintId())
    : null;
  if (highlightId === appliedHighlightId) return;

  clearSidebarRowHighlights();
  if (!highlightId) return;

  const row = document.querySelector(
    `[data-sidebar-campaign-id="${highlightId}"]`,
  );
  if (row) {
    row.classList.add('sidebar__item--drag-over');
    row.setAttribute(MISSION_DROP_ATTR, 'true');
    appliedHighlightId = highlightId;
  }
}

export function resetVisualSyncTracking() {
  appliedVisualClasses = { active: false, overSidebar: false };
  appliedHighlightId = null;
}
